import { put, call, takeEvery } from "redux-saga/effects";
import athenaClient from "lib/axios/clients";
import buildRequestUrl from "lib/requests/requestUtils";
import _ from "lodash";
import { addAreasList } from "./slices";
import addAreasListAsyncAction from "./actions";

function* addAreasListAsync(action) {
  const url = buildRequestUrl(action.payload, "areas");

  const config = {
    method: "GET",
    url,
  };

  const response = yield call(athenaClient, config);

  yield put(addAreasList(_.keyBy(response.data, "id")));
}

export default function* watchAddAreasListAsync() {
  yield takeEvery(addAreasListAsyncAction, addAreasListAsync);
}
